import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { LanguageService, I18nModule } from '@spartacus/core';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'app-password-strength-meter',
    templateUrl: './password-strength-meter.component.html',
    styleUrls: ['./password-strength-meter.component.scss'],
    imports: [NgClass, NgIf, I18nModule]
})
export class PasswordStrengthMeterComponent implements OnInit, OnChanges {
  @Input() password: string;
  @Input() smallupcaseCheck = true;
  @Input() minLength = 8;
  @Input() specialCharCheck = true;
  @Output() strengthChange = new EventEmitter<number>();

  public score = 0;
  // tslint:disable-next-line:ban-types
  public feedbackArr: Array<Object> = [];
  error: any;
  public feedbackArrDefault = [];
  status3: boolean;
  status1: boolean;
  status2: boolean;
  currentLang: string;
  constructor(private languageService: LanguageService) { }

  // tslint:disable-next-line:typedef
  ngOnInit() {
    this.languageService.getActive().subscribe(resp=>{
      this.currentLang = resp;
    })
  }

  // tslint:disable-next-line:typedef
  ngOnChanges(changes: SimpleChanges) {
    if (changes.password ) {
      this.checkStrength();
    }
  }

  // tslint:disable-next-line:typedef
  checkStrength() {
    let totalCriteria = 1; // One is always there becuse there will be atleast 8 char length check
    totalCriteria = this.specialCharCheck ? totalCriteria + 1 : totalCriteria;
    totalCriteria = this.isSmallUpcaseMet  ? totalCriteria + 1 : totalCriteria;

    this.feedbackArr = [];
    this.score = 0;
    // tslint:disable-next-line:max-line-length
    this.score = this.isSmallUpcaseMet && this.isSmallUpcaseMet()     ? this.score + parseFloat((100 / totalCriteria).toFixed(2)) : this.score;
    this.score = this.isLengthMet()       ? this.score + parseFloat((100 / totalCriteria).toFixed(2)) : this.score;
    this.score = this.specialCharCheck && this.isSpecialCharMet() ? this.score + parseFloat((100 / totalCriteria).toFixed(2)) : this.score;

    }
  // tslint:disable-next-line:typedef
  isSmallUpcaseMet() {
    if ( (/[a-z]/).test(this.password) && (/[A-Z]/).test(this.password)) {
      this.status1 = true ;
      return true;
    } else {
      this.status1 = false ;
      return false;
    }
  }
  // tslint:disable-next-line:typedef
  isLengthMet() {

    if (this.password.length >= this.minLength) {
      this.status2 = true ;
      return true;
    } else {
      this.status2 = false ;
      return false;
    }
  }
  // tslint:disable-next-line:typedef
  isSpecialCharMet() {
    if ( (/[!@#$%*]/).test(this.password) ) {
      this.status3 = true ;
      return true;
    } else {
      this.status3 = false ;
      return false;
    }
  }

}
